<template>
  <div id="app">
    <notifications group="user-info" position="bottom center"/>
    <notifications group="notification" position="top right"/>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  watch: {
      '$route' (to, from) {
        document.title = to.meta.title || 'SaveAnimals.in | Wildlife Trust of India'
      }
    },
}
</script>

<style lang="scss">
  // Import Main styles for this application
  @import 'assets/scss/style';
</style>
